import React from 'react';
//import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import './index.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'

import store from './redux/store'
import axios from 'axios';


axios.interceptors.request.use(request => {
    const token = localStorage.token;
    request.headers.Authorization = "Bearer " + token
    request.headers['Content-Type'] = 'application/json';
    return request;
})

axios.interceptors.response.use(response => {
    console.log(response.status)
    return response
})

//const root = ReactDOM.createRoot(document.getElementById('root'));
const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
